// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","433":"62f69b35","472":"a368b6a5","490":"a5bbeaac","755":"989c0007","808":"d6303b47","849":"5e3754ac","952":"1381c032","977":"4b3215a8"}[chunkId] + ".chunk.js";
};